import './_list-attachments.scss';
import './_attachment.scss';

/*
 * This function create for list attachments component and integrated logic for accessibility.
 * */

export default function ListAttachments() {
    const $listEntities = document.querySelectorAll('.list-entities');

    $listEntities.forEach(($listEntity: any) => {
        function init() {
            if (window.innerWidth < 992) {
                const $titlePlaceholder = $listEntity.querySelector('.title-container');
                const $titleMobile = $titlePlaceholder.querySelector('.title-mobile');
                const $btnMobile = $titleMobile.querySelector('.title-filters');
                const $filterMobile = $listEntity.querySelector('.filters.template');
                const $filters = $listEntity.querySelector('.filters.template');
                const $closeFilters = $filters.querySelector('.close-filters');
                const $applyBtn = $filters.querySelector('.apply-filters') as HTMLElement;

                $btnMobile.addEventListener('click', () => {
                    $filterMobile.classList.remove('closed');
                    $filterMobile.classList.add('open');
                    document.body.classList.add('has-mask');
                });

                $btnMobile.addEventListener('keyup', (e: KeyboardEvent) => {
                    if (e.key === 'Enter') {
                        $filterMobile.classList.remove('closed');
                        $filterMobile.classList.add('open');
                        document.body.classList.add('has-mask');
                    }
                });

                $closeFilters.addEventListener('click', () => {
                    $filterMobile.classList.remove('open');
                    $filterMobile.classList.add('closed');
                    document.body.classList.remove('has-mask');
                });

                $closeFilters.addEventListener('keyup', (e: KeyboardEvent) => {
                    if (e.key === 'Enter') {
                        $filterMobile.classList.remove('open');
                        $filterMobile.classList.add('closed');
                        document.body.classList.remove('has-mask');
                    }
                });

                document.addEventListener('scroll', () => {
                    if (document.documentElement.scrollTop > $titlePlaceholder.offsetTop + 60) {
                        $titleMobile.classList.add('fixed');
                    } else {
                        $titleMobile.classList.remove('fixed');
                    }
                });

                document.addEventListener('keydown', function (event) {
                    if (event.key === 'Tab') {
                        if (event.shiftKey) {
                            if (document.activeElement === $closeFilters) {
                                event.preventDefault();
                                $applyBtn.focus();
                            }
                        } else {
                            if (document.activeElement === $applyBtn) {
                                event.preventDefault();
                                $closeFilters.focus();
                            }
                        }
                    }
                });

                document.addEventListener('click', (e: any) => {
                    const currentEL = e.target;
                    const $clicked = currentEL as any;

                    if ($clicked.contains(document.body)) {
                        $filterMobile.classList.remove('open');
                    }
                });

                document.addEventListener('keyup', (e: KeyboardEvent) => {
                    if (e.key === 'Escape') {
                        $filterMobile.classList.remove('open');
                    }
                });
            }
        }

        init();
    });
}
